import { Glue42 } from "../../../glue";
import JumpListActions from "./actions";
import jumpListManager from "./manager";

export default class JumpListCategories implements Glue42.Windows.JumpListCategoriesAPI {

    constructor(private windowId: string) {
    }

    public list(): Promise<Glue42.Windows.JumpListCategory[]> {
        return this.getCategories();
    }

    public create(title: string, actions: Glue42.Windows.JumpListActionSettings[]): Promise<void> {
        return jumpListManager.createCategory(this.windowId, title, actions);
    }

    public remove(title: string): Promise<void> {
        return jumpListManager.removeCategory(this.windowId, title);
    }

    public async find(title: string): Promise<Glue42.Windows.JumpListCategory> {
        const categories = await this.getCategories();
        return categories.find((cat) => cat.title === title);
    }

    private async getCategories(): Promise<Glue42.Windows.JumpListCategory[]> {
        const result: Glue42.Windows.JumpListCategory[] = [];

        const configuration = await jumpListManager.getJumpListSettings(this.windowId);
        configuration.categories.forEach((category) => {
            result.push({
                title: category.title,
                actions: new JumpListActions(this.windowId, category)
            });
        });
        return result;
    }
}
